import { Video, VideoResponse } from './types';

const stripHtml = (value: string) => value.replace(/<[^>]*>/g, ' ');

const collectVideoSearchText = (video: Video): string => {
  const parts: (string | null | undefined)[] = [
    video.title_en,
    video.title_nl,
    video.description_en,
    video.description_nl,
    video.description_fr,
    video.description_de,
    video.producer_text_nl,
    video.producer_text_en,
    video.producer_text_fr,
    video.producer_text_de,
    video.handwriting_title_nl,
    video.handwriting_title_en,
    video.handwriting_title_fr,
    video.handwriting_title_de,
    video.producer_ensemble?.name,
    video.producer_url,
  ];

  return parts
    .filter((p): p is string => typeof p === 'string' && p.length > 0)
    .map((p) => stripHtml(p))
    .join(' ')
    .toLowerCase();
};

const videoMatchesSearch = (video: Video, query: string): boolean => {
  const q = query.trim().toLowerCase();
  if (!q) {
    return true;
  }
  return collectVideoSearchText(video).includes(q);
};

export const filterVideoResponseBySearch = (
  data: VideoResponse,
  query: string,
): VideoResponse => {
  const q = query.trim();
  if (!q) {
    return data;
  }

  return {
    ...data,
    docu_series: data.docu_series.map((series) => ({
      ...series,
      videos: series.videos.filter(({ video }) => videoMatchesSearch(video, q)),
    })),
  };
};
